export default {"src":"/_next/static/media/map.75d587dc.svg","height":48,"width":50,"blurWidth":0,"blurHeight":0};